<template>
  <div class="p-2">
    <AccountStatusComponent v-if="showAccountStatusComponent" mobile />
    <RewardsComponent v-if="false && showAccountStatusComponent" mobile />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { localeChanged, localize } from 'vee-validate'
import { locales } from '@/libs/i18n/all-locales'
import AccountStatusComponent from './components/Index.vue'
import RewardsComponent from '../rewards/components/Index.vue'

export default {
  name: 'AccountStatusMobile',
  components: {
    AccountStatusComponent,
    RewardsComponent,
  },
  data() {
    return {
      showAccountStatusComponent: false,
    }
  },
  created() {
    // Önceki key'leri temizle
    useJwt.setToken(null)
    useJwt.setApiKey(null)

    const token = this.$cookies.get('token')
    const apiKey = this.$cookies.get('api-key')
    const locale = this.$cookies.get('locale')

    // Cookie'den dil geldiyse o dili ayarla
    if (locale) {
      const selectedLocale = locales.find(l => l.locale === locale)

      if (selectedLocale) {
        this.updateLocale(locale)
      }
    }

    if (token && apiKey) {
      useJwt.setToken(token)
      useJwt.setApiKey(apiKey)

      setTimeout(() => {
        this.showAccountStatusComponent = true
      }, 33)
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale
      localize(locale)
      localeChanged()
      localStorage.setItem('locale', locale)

      if (locale === 'ar') {
        localStorage.setItem('isRTL', 'on')
      }
      this.$store.commit('appConfig/TOGGLE_RTL', locale === 'ar')

      this.updateLocaleFromServer(locale)
    },
    updateLocaleFromServer(lang) {
      if (lang) {
        useJwt.updateLanguage(lang)
      }
    },
  },
}
</script>
